export enum GOOGLE_ANALYTICS_EVENTS {
  FORM_START = 'form_start',
  FORM_SUBMIT = 'form_submit',
}

export const HUBSPOT = 'hubspot';
